<template>
  <div class="molecule-department" @click="onClickEdit">
    <div class="row align-items-center d-none d-md-flex">
      <div class="col-1">
        <div class="d-flex align-items-center flex-column">
          <div class="department-order__number">#{{ index }}</div>
        </div>
      </div>
      <div class="col-9 text-semibold-black">
        {{ name }}
      </div>
      <div class="col-2 d-flex justify-content-end">
        <div @click.stop="onClickDelete()">
          <atom-button
            buttonId="button-delete"
            iconLeft="Trash2Icon"
            buttonStyle="flat"
            buttonColor="secondary"
          ></atom-button>
        </div>
      </div>
    </div>

    <div class="row align-items-center d-md-none">
      <div class="col-10">{{ name }}</div>
      <div class="col-2 d-flex justify-content-end">
        <div @click.stop="onClickDelete()">
          <atom-button
            buttonId="button-delete"
            iconLeft="Trash2Icon"
            buttonStyle="flat"
            buttonColor="secondary"
          ></atom-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AtomButton from "@/components/atoms/AtomButton.vue"

export default {
  name: "MoleculeLocationItem",
  components: { AtomButton },
  props: {
    index: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: false,
      default: "",
    },
  },

  methods: {
    onClickEdit() {
      this.$emit("onClickEdit")
    },
    onClickDelete() {
      this.$emit("onClickDelete")
    },
  },
}
</script>

<style lang="scss" scoped>
.molecule-department {
  border-radius: 6px;
  border: 1px solid #ebe9f1;
  color: #6e6b7b;
  font-size: 12px;
  padding: 5px 15px;

  &:hover {
    background-color: #f6f6f9;
    cursor: pointer;
  }
}
.department__primary {
  border: 1px solid #7367f0;
  color: #7367f0;
}

.department-order {
  font-size: 8px;
}

.department-order__number {
  font-size: 10px;
}

.department-support {
  border-left: 1px solid #ebe9f1;
  border-right: 1px solid #ebe9f1;
  display: flex;
  justify-content: center;
}
</style>
